import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Check if this is a network/backend connection error
    if (error.message.includes('Unable to connect to server') ||
        error.message.includes('Network connection failed') ||
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Connection refused')) {
      
      // Clear any stored session since backend is unreachable
      localStorage.removeItem('userSession');
      
      // Redirect to login page
      window.location.href = '/login';
    }
  }

  public render() {
    if (this.state.hasError) {
      // Check if it's a network error
      if (this.state.error?.message.includes('Unable to connect to server') ||
          this.state.error?.message.includes('Network connection failed') ||
          this.state.error?.message.includes('Failed to fetch')) {
        // Don't render anything, let the redirect happen
        return null;
      }
      
      // For other errors, show a generic error message
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          backgroundColor: '#f5f5f5',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page and try again.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 